/**
 * What a bag item does here, in one football line (slice 11, the roster screen's bag), built from
 * its effect in balance.json `items` like `moveLine`: never written per item. The bag's rules are
 * the sim's (subs.ts applyWindow): spent once, between plays, on any of the team, and an HP item
 * works at 0 HP.
 */
import type { ItemEffect } from '@tdmons/sim';

export type BagEffect = Extract<ItemEffect, { kind: 'heal-hp' | 'cure-status' }>;

/** "Heals 20 HP · once, between plays · works at 0 HP". */
export function itemLine(e: BagEffect): string {
  switch (e.kind) {
    case 'heal-hp':
      return `Heals ${e.hp} HP · once, between plays · works at 0 HP`;
    case 'cure-status':
      return 'Cures any status · once, between plays';
  }
}
